const cn = {
  c_login: '登录',
  c_s_chat: '单聊',
  c_g_chat: '群聊',
  c_logout: '退出登录',
  c_cochat: '联想乐聊',
  c_reset: '重置',
  c_download: '下载',
  c_start: '开始日期',
  c_end: '结束日期',
  c_nohistory: '没有消息记录',
  c_rong: '融云(V5.5及以后版本)',
  c_ji: '极光(V5.4及以前版本)',
  c_total: '一共有',
  c_records: '条记录',
  c_downfinish: '导出成功',
  c_go: '前往',
  c_page: '页',
  c_kown:'我知道了',
  c_search: 'ITCode/群名',
  c_showall: '查看全部',
  c_hide: '收起全部',
  c_time:'结束时间不能早于开始时间,请重新选择.',
  PleaseUser: '请输入ITCode',
  PleasePwd: '请输入密码',
  PleaseOtp: '请输入动态口令',
  Lrzgw: '乐认证官网',

  adDesc: '根据联想安全策略，AD用户登录乐聊需要使用乐认证 动态口令，如果您首次使用动态口令，请点击OTP官网了解',
}
const en = {
  c_login: 'Login',
  c_s_chat: 'Single Chat',
  c_g_chat: 'Group Chat',
  c_logout: 'Log Out',
  c_cochat: 'Lenovo CoChat',
  c_reset: 'Reset',
  c_download: 'Download',
  c_start: 'Start Date',
  c_end: 'End Date',
  c_kown:'Got it',
  c_nohistory: 'No Chat History',
  c_rong: ' RongCloud(V5.5 and above)',
  c_ji: 'JIGUANG(V5.4 and below)',
  c_total: 'A total of',
  c_records: 'records',
  c_go: 'Go to',
  c_page: 'Page',
  c_downfinish: 'Export successful',
  c_search: 'ITCode/Group Name',
  c_showall: 'Show All',
  c_hide: 'Hide All',
  c_time:'Please re-select, because the end-time cannot be earlier than start-time.',
  PleaseUser: 'ITCode',
  PleasePwd: 'Password',
  PleaseOtp: 'OTP',
  Lrzgw: 'OTP official Website:',
  adDesc: 'According to Lenovo security policy, AD users need to verify OTP code when login to CoChat. Visit OTP official website to get more information.',
}
export {
  cn,
  en
}



// WEBPACK FOOTER //
// ./src/assets/commonjs/language.js